import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const Header = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Content = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export const FormSection = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SidebarSection = styled.div`
  width: 400px;
  flex-shrink: 0;

  @media (max-width: 960px) {
    width: 100%;
  }
`;

export const TemplateBlock = styled.div`
  background: ${(props) => props.theme.palette[100]};
  border: 1px solid ${(props) => props.theme.palette[300]};
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TemplateHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const AddLanguageSection = styled.div`
  background: ${(props) => props.theme.palette[100]};
  border: 1px solid ${(props) => props.theme.palette[300]};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AddLanguageControls = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const HelpSection = styled.div`
  background: ${(props) => props.theme.palette[200]};
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const VariablesHint = styled.div`
  background: ${(props) => props.theme.palette[200]};
  border-radius: 8px;
  padding: 20px;
  position: sticky;
  top: 20px;
`;

export const VariablesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const VariableTag = styled.span`
  background-color: ${(props) => props.theme.palette[700]};
  color: ${(props) => props.theme.palette[10]};
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-family: monospace;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background-color: ${(props) => props.theme.palette[800]};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const FormActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${(props) => props.theme.palette[300]};
`;
